import { Tabs } from "antd";
import ProductsList from "./ProductsList";
import CustomProductsList from "./CustomProductsList";
import QcRequestsList from "./QcRequestsList";
import { useEffect, useState } from "react";
import { useTranslation } from "../../../../../context/TranslationContext";
const OrderdetailTabs = ({
  orderDetails = [],
  vendorDetailsData = [],
  status,
  qcRequestData,
  qcData,
  totalPrepTime,
  orderDeliveryType,
  rhOrderJson,
  platformOfOrder,
  isGuest,
  orderType
}) => {
  const { t } = useTranslation();
  const [itemList, setItemList] = useState([]);
  // const [vehicleType, setVehicleType] = useState("");

  // function getVehicleTypeName(item) {
  //     return (
  //       item?.orderItemJson?.vehicleType ||
  //       item?.orderItemDetails?.vehicleType ||
  //       item?.orderItemJson?.productUom?.vehicleType?.name ||
  //       item?.orderItemDetails?.productUom?.vehicleType?.name ||
  //       null
  //     );
  //   }
    useEffect(() => {
    setItemList(vendorDetailsData);
  }, [orderDetails, vendorDetailsData]);

  // useEffect(() => {
  //   if (!rhOrderJson?.orderDetails?.length) return;
  //   const vehicleTypeName = getVehicleTypeName(rhOrderJson.orderDetails[0]);
  //   if (vehicleTypeName) setVehicleType(vehicleTypeName);
  // }, [rhOrderJson]);

  return (
    <>
      <div className="px-9 py-5 flex justify-between border-gray-250 border-b w-full">
        <div className="relative w-full tab-nav-transparent">
          <Tabs defaultActiveKey="1" className="bg-transparent">
            <Tabs.TabPane tab={<>{t("products")}</>} key={1}>
              {Array.isArray(vendorDetailsData) && vendorDetailsData.length > 0 ? itemList?.map((item, index) => {
                return (
                  <div className="" key={index}>
                    <h2 className="text-base font-semibold ">
                      {item?.vendorName}
                    </h2>
                    <div className="">
                      {item?.orderDetails?.map((itm, idx) => {
                        const rhOrderDetail = rhOrderJson?.orderDetails?.[idx] || null;
                        if (itm?.type === "product") {
                          return (
                            <ProductsList
                              key={idx}
                              order={itm}
                              qcRequestData={qcRequestData}
                              status={status}
                              orderDeliveryType={orderDeliveryType}
                              platformOfOrder={platformOfOrder}
                              rhOrderDetail={rhOrderDetail}
                              orderType={orderType}
                            />
                          );
                        } else {
                          return (
                            <CustomProductsList
                              key={idx}
                              order={itm}
                              index={idx}
                              qcRequestData={qcRequestData}
                              status={status}
                              orderDeliveryType={orderDeliveryType}
                              isGuest={isGuest}
                              platformOfOrder={platformOfOrder}
                              rhOrderDetail={rhOrderDetail}
                              orderType={orderType}
                            />
                          );
                        }
                      })}
                    </div>
                  </div>
                );
              }) :
                <div className="">
                  {orderDetails?.map((itm, index) => {
                    const rhOrderDetail = rhOrderJson?.orderDetails?.[index] || null;
                    if (itm?.type === "product") {
                      return (
                        <ProductsList
                          key={index}
                          order={itm}
                          qcRequestData={qcRequestData}
                          status={status}
                          orderDeliveryType={orderDeliveryType}
                          platformOfOrder={platformOfOrder}
                          rhOrderDetail={rhOrderDetail}
                          orderType={orderType}
                        />
                      );
                    } else {
                      return (
                        <CustomProductsList
                          key={index}
                          order={itm}
                          index={index}
                          qcRequestData={qcRequestData}
                          status={status}
                          orderDeliveryType={orderDeliveryType}
                          isGuest={isGuest}
                          platformOfOrder={platformOfOrder}
                          rhOrderDetail={rhOrderDetail}
                          orderType={orderType}
                        />
                      );
                    }
                  })}
                </div>}
            </Tabs.TabPane>
            {qcRequestData.length > 0 ? (
              <Tabs.TabPane tab={<>QC Requests</>} key={2}>
                <QcRequestsList
                  qcRequestData={qcRequestData}
                  orderDetails={orderDetails}
                  qcData={qcData}
                />
              </Tabs.TabPane>
            ) : null}
          </Tabs>
          <div className="absolute top-0 right-0 bg-[#cccccc] py-1 px-3 rounded-sm whitespace-nowrap">
            {t("estimatedPrepTime")} {totalPrepTime} {t("min")}
          </div>
        </div>
      </div>
    </>
  );
};
export default OrderdetailTabs;
